import { createStore } from 'vuex'

export default createStore({
  state: {
    flightBookData: null,
    flightData: null,
    flightSearchData: {}
  },
  mutations: {
    setFlightBookData(state, data) {
      state.flightBookData = data
    },
    setFlightData(state, data) {
      state.flightData = data
    },
    setFlightSearchData(state, data) {
      state.flightSearchData = data
    }
  },
  actions: {
    setFlightBookData({ commit }, data) {
      commit('setFlightBookData', data)
    },
    setFlightData({ commit }, data) {
      commit('setFlightData', data)
    },
    setFlightSearchData({ commit }, data) {
      commit('setFlightSearchData', data)
    }
  },
  getters: {
    getFlightBookData(state) {
      return state.flightBookData
    },
    getFlightData(state) {
      return state.flightData
    },
    getFlightSearchData(state) {
      return state.flightSearchData
    }
  }
})